import React, { useContext, useEffect, useState } from "react";
import "./childHeader.css";
import BreadCrumbComponent from "components/ui/BreadCrumb";
import { Outlet, useLocation } from "react-router-dom";
import IconsChild from "./SubComponets/IconsChild";
import SortContext from "context/SortContext";
import { useGlobalContext } from "context/GlobalContext";

function ChildHeaderLayout({ pageName, icon, deIcon, categoryCountWithDesgin }) {
  const { setIsEdit, isEditClick, setIsEditClick } = useContext(SortContext);
  const historyState = window.history.state;
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const location = useLocation();
  const state = location.state;

  const { filterChangeCount, setFilterChangeCount, setFilterChangeDesignCount, setDisplayCount, setSearchSuffix } = useGlobalContext();

  const isExactMatch = location.pathname === `/${pageName}` || location.pathname === `/${pageName.replace(/s$/, "")}`;

  const useQuery = () => {
    return new URLSearchParams(location.search);
  };

  const query = useQuery();
  let nextName = [];

  if (pageName !== "aiStock") {
    nextName = [pageName];
  }

  nextName = nextName.concat(query.getAll("name"));

  //console.log("Child header ",location)

  // Set count values from categoryCountWithDesgin for Stock, Category, Catalog, and Sets pages
  useEffect(() => {
    if (categoryCountWithDesgin && Object.keys(categoryCountWithDesgin).length > 0) {
      const pathnames = location.pathname.split("/").filter((x) => x);
      const isStockPage = pathnames[0] === "Stock" && pathnames.length === 1;
      const isCategoryPage = pathnames[0] === "Category" && pathnames.length === 1;
      const isCatalogPage = pathnames[0] === "Catalog" && pathnames.length === 1;
      const isSetPage = pathnames[0] === "Sets" && pathnames.length === 1;

      if (isStockPage || isCategoryPage || isCatalogPage || isSetPage) {
        // For Stock pages - categoryCountWithDesgin should have totalCount (categories) and totalStyles (articles)
        if (isStockPage) {
          const categoryCount = categoryCountWithDesgin.totalCount || categoryCountWithDesgin.categoryCount || 0;
          const articleCount = categoryCountWithDesgin.totalStyles || categoryCountWithDesgin.totalDesigncount || categoryCountWithDesgin.totalArticles || 0;
          setFilterChangeCount(categoryCount);
          setFilterChangeDesignCount(articleCount);
          setSearchSuffix("Articles");
          setDisplayCount(true);
        }
        // For Category pages
        else if (isCategoryPage) {
          const categoryCount = categoryCountWithDesgin.totalCount || 0;
          const designCount = categoryCountWithDesgin.totalDesigncount || 0;
          setFilterChangeCount(categoryCount);
          setFilterChangeDesignCount(designCount);
          setSearchSuffix("Designs");
          setDisplayCount(true);
        }
        // For Catalog pages
        else if (isCatalogPage) {
          const catalogCount = categoryCountWithDesgin.totalCatalogs || 0;
          setFilterChangeCount(catalogCount);
          setSearchSuffix("Designs");
          setDisplayCount(true);
        }
        // For Sets pages
        else if (isSetPage) {
          const setCount = categoryCountWithDesgin.totalSets || 0;
          setFilterChangeCount(setCount);
          setSearchSuffix("Designs");
          setDisplayCount(true);
        }
      }
    }
  }, [categoryCountWithDesgin, location.pathname, setFilterChangeCount, setFilterChangeDesignCount, setDisplayCount, setSearchSuffix]);

  useEffect(() => {
    const pathnames = location.pathname.split("/").filter((x) => x);

    const newBreadcrumbs = [];

    let newPath = "";

    if (!location.pathname.includes("Sets")) {
      setIsEditClick(false);
    }

    if (pathnames[0] !== "aiStock") {
      pathnames.forEach((name, index) => {
        newPath = newPath + "/" + name;
        newBreadcrumbs.push({
          // name: nextName[index] ? nextName[index] : state ? state.name[index - 1] : "",
          name: nextName[index] ? nextName[index] : historyState?.name?.[index - 1] || state?.name?.[index - 1] || "",
          path: newPath,
          count: state?.count,
        });
      });
    } else {
      const aiStockBasePath = `/${pathnames[0]}/${pathnames[1]}/${pathnames[2]}`;
      newBreadcrumbs.push({
        name: pathnames[2],
        path: aiStockBasePath,
        count: state?.count,
      });
      if (pathnames.length > 3 && state?.name?.length > 0) {
        state.name.forEach((name) => {
          newBreadcrumbs.push({ name, path: location.pathname });
        });
      }
    }

    if (state && state.isActivity) {
      newBreadcrumbs.push({
        name: "Activity",
        path: "",
      });
    }

    if (state && state.subName) {
      newBreadcrumbs.push({
        name: state.subName,
        path: "",
        count: state?.count,
      });
    }

    if (isEditClick && !location.pathname.includes("/Sets/")) {
      newBreadcrumbs.push({
        name: "Archive",
        path: "",
        count: state?.count,
      });
    }

    setBreadcrumbs(newBreadcrumbs.filter((b) => b.name));
  }, [location, isEditClick, filterChangeCount]);

  const handleBreadcrumbClick = (breadcrumb) => {
    // alert("Bread crummb clicked ");
    if (breadcrumb.name === "Set") {
      setIsEditClick(false);
      setIsEdit("view");
    }
  };

  return (
    <>
      <div className="child-header" style={{ borderBottom: location.pathname === "/CartOrder" ? "2px solid rgba(7, 6, 6, 1)" : "" }}>
        <div className="child-header-sub" style={{ justifyContent: location.pathname === "/CartOrder" ? "flex-start" : "" }}>
          {isExactMatch ? icon : deIcon}
          <BreadCrumbComponent breadcrumbs={breadcrumbs} onBreadcrumbClick={handleBreadcrumbClick} />
        </div>
        <div className="child-header-icon">
          <IconsChild location={location} />
        </div>
      </div>
      <div className="child-header-content" style={{ paddingInline: location.pathname === "/CartOrder" ? "5px" : "10px" }}>
        <Outlet />
      </div>
    </>
  );
}

export default ChildHeaderLayout;
